import { render, staticRenderFns } from "./urgentDetails.vue?vue&type=template&id=699bc185&"
import script from "./urgentDetails.vue?vue&type=script&lang=js&"
export * from "./urgentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports